import BrandTagline from './BrandTagline';
import {productConfig} from '@/lib/productConfig';
import { COMPANY } from "@/lib/company";
import { Link } from "react-router-dom";
import { LOGO, SITE } from "@/lib/site";

const productLinks = [
  { to: "/how-it-works", label: "How It Works" },
  { to: "/people", label: "People" },
  { to: "/vibes", label: "Vibes" },
  { to: "/faqs", label: "FAQs" },
  { to: "/business", label: "Business" },
  { to: "/pricing", label: "Pricing" },
  { to: "/how-orrbitt-uses-ai", label: "Matching" },
];

const safetyLinks = [
  { to: "/safety", label: "Safety Centre" },
  { to: "/community-guidelines", label: "Community Guidelines" },
  { to: "/location-privacy", label: "Location Privacy" },
  { to: "/photo-verification", label: "Photo Verification" },
  { to: "/report", label: "Report a Concern" },
];

const legalLinks = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms" },
  { to: "/policies", label: "All Policies" },
  { to: "/delete-account", label: "Account Deletion" },
  { to: "/refunds", label: "Previous Purchases & Refunds" },
];

const companyLinks = [
  { to: "/about", label: "About" },
  { to: "/benefits-of-human-connection", label: "Benefits of Human Connection" },
  { to: "/support", label: "Support" },
  { to: "/download", label: "Get the App" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-lightbg">
      <div className="container-x py-14">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-12">
          <div className="col-span-2 md:col-span-3">
            <img src={LOGO} alt="Orrbbit" className="h-7 w-auto" />
            <BrandTagline/>
            <p className="mt-4 text-sm text-bodygrey">
              <a href={`mailto:${SITE.supportEmail}`} className="font-medium text-teal hover:underline">
                {SITE.supportEmail}
              </a>
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-navy">Product</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {productLinks.filter(l=>(productConfig.businessEnabled||!l.to.startsWith('/business'))&&(productConfig.peopleMonetizationEnabled||l.to!=='/pricing')).map((l) => (
                <li key={l.label}><Link className="text-bodygrey hover:text-teal" to={l.to}>{l.label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-navy">Safety</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {safetyLinks.map((l) => (
                <li key={l.label}><Link className="text-bodygrey hover:text-teal" to={l.to}>{l.label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-navy">Legal</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {legalLinks.map((l) => (
                <li key={l.label}>
                  <Link className="text-bodygrey hover:text-teal" to={l.to}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-navy">Company</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {companyLinks.map((l) => (
                <li key={l.label}><Link className="text-bodygrey hover:text-teal" to={l.to}>{l.label}</Link></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-border pt-6 text-sm text-bodygrey md:flex-row md:items-center">
          <div><p>© {year} Orrbbit. All rights reserved.</p><p className="mt-2 text-xs leading-relaxed">Orrbbit is operated by {COMPANY.name}.<br/>ABN {COMPANY.abn} · ACN {COMPANY.acn}</p></div>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link to="/privacy" className="hover:text-teal">Privacy</Link>
            <Link to="/terms" className="hover:text-teal">Terms</Link>
            <Link to="/cookies" className="hover:text-teal">Cookies</Link>
            <Link to="/policies" className="hover:text-teal">All Policies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

